import { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DragImg from "../../assets/images/icon_draganddrop.png";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";

import {
  getStudentTeacherFavorite,
  postStudentTeacherFavorite,
  deleteStudentTeacherFavorite,
  postStudentTeacherRestriction,
  deleteStudentTeacherRestriction,
  updateStudentTeacherFavoriteOrder,
  updateStudentFavoriteTeacherFlag,
} from "../../store/middleware/companyManager.middleware";
import { setTeachers } from "../../store/slices/generics.slice";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { getStudentTeacherRestriction } from "../../store/middleware";
import { getTeachersAll } from "../../store/middleware/generic.middleware";
import PlacehoderText from "../../components/Placeholder/PlaceholderText";
import avatar_default from "../../assets/images/profile/img_placeholder.svg";

import { StudentTeacher } from "./styles";

function Teachers() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { allTeachers } = useSelector((state) => state.genericReducer);
  const { studentManagement } = useSelector((state) => state.companyManagerReducer);

  const studentId = studentManagement.students[0].id;

  const [teacherId, setTeacherId] = useState("");
  const [isFavorite, setIsFavorite] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [scheduleclass, setScheduleclass] = useState("");
  const [teacherFavorites, setTeacherFavorites] = useState("");
  const [alertDescription, setAlertDescription] = useState("");
  const [teacherExceptions, setTeacherExceptions] = useState([]);

  const getData = () => {
    dispatch(getTeachersAll());
    loadFavorites(null, -1);
    loadExceptions();
  };

  const loadFavorites = async (e, order) => {
    await dispatch(getStudentTeacherFavorite(studentId)).then(async (res) => {
      res.forEach((obj, index) => (obj.order = index + 1));
      setTeacherFavorites(res);

      if (order && order > -1) {
        order = order > res?.length - 1 ? res?.length - 1 : order;
        const index = {
          newIndex: res?.length - 1,
          oldIndex: order,
        };
        await onSortEnd(index, e);
      }

      removeArrayTeacherFavorites();
    });
  };

  const loadExceptions = () => {
    dispatch(getStudentTeacherRestriction(studentId)).then((res) => {
      setTeacherExceptions(res);
      removeArrayTeacherExceptions();
    });
  };

  const removeArrayTeacherExceptions = () => {
    let tempTeacher = allTeachers;
    teacherExceptions?.map((el) => {
      tempTeacher = tempTeacher.filter((e) => e.id !== el.teacher.id);
    });
    setTeachers(tempTeacher);
  };

  const removeArrayTeacherFavorites = () => {
    let tempTeacher = allTeachers;
    teacherFavorites.length &&
      teacherFavorites?.map((el) => {
        tempTeacher = tempTeacher.filter((e) => e.id !== el.teacher.id);
      });
    setTeachers(tempTeacher);
  };

  const addTeacher = (e) => {
    e.preventDefault();

    if (studentId === 0 || teacherId === null) {
      setOpenAlert(true);
      setAlertDescription(t("SELECT_TEACHER"));
      return;
    }

    let newobj = {
      studentId: parseInt(studentId),
      teacherId: parseInt(teacherId),
    };

    if (isFavorite) {
      dispatch(postStudentTeacherFavorite(newobj))
        .then((res) => {
          res.forEach((obj, index) => (obj.order = index + 1));
          setTeacherFavorites(res);
        })
        .catch((e) => console.log(e));
    } else {
      dispatch(postStudentTeacherRestriction(newobj))
        .then(() => loadExceptions())
        .catch((e) => console.log(e));
    }
  };

  const deleteTeacher = (e, order) => {
    const { value, name } = e.target;
    if (name === "favorite") {
      dispatch(deleteStudentTeacherFavorite(value)).then(() => loadFavorites(e, order));
    } else if (name === "exception") {
      dispatch(deleteStudentTeacherRestriction(value)).then(() => loadExceptions());
    }
  };

  const onSortEnd = async (index) => {
    let favorites = teacherFavorites;
    if (!favorites[index.oldIndex]) return;

    favorites[index.oldIndex].order = index.newIndex + (index.oldIndex < index.newIndex ? 1.1 : 0.1);
    favorites.sort(function (left, right) {
      return left.order < right.order ? -1 : 1;
    });

    let studentTeacherFavoriteIds = [];
    for (let index = 0; index < favorites.length; index++) {
      favorites[index].order = index + 1;
      studentTeacherFavoriteIds.push(favorites[index].id);
    }

    let newobj = {
      studentId: parseInt(studentId),
      studentTeacherFavoriteIds: studentTeacherFavoriteIds,
    };

    await dispatch(updateStudentTeacherFavoriteOrder(newobj)).then((res) => {
      res.forEach((obj, index) => (obj.order = index + 1));
      setTeacherFavorites(res);
    });
  };

  const handleChange = (e) => {
    e.preventDefault();

    if (e.target.name === "favorite") {
      setIsFavorite(true);
    } else if (e.target.name === "exception") {
      setIsFavorite(false);
    } else {
      setTeacherId(e.target.value);
    }
  };

  const handleScheduleClass = (e) => {
    const value = e.target.checked;

    dispatch(updateStudentFavoriteTeacherFlag(studentId, value))
      .then(() => setScheduleclass((state) => !state))
      .catch((err) => console.log(err));
  };

  const DragHandle = SortableHandle(() => <img src={DragImg} alt="Drag Drop"></img>);

  const SortableItem = SortableElement(({ value }) => (
    <div key={value.id} className="bigBoxTeacher">
      <div className="boxInfo">
        <div className="boxColumn">
          <label>
            {value.order}
            {value.order === 1 && "st"}
            {value.order === 2 && "nd"}
            {value.order === 3 && "rd"}
            {value.order >= 4 && "th"}
          </label>
        </div>
        <div className="boxColumn">
          <img
            alt="Avatar"
            width="48"
            height="48"
            className="avatarRound"
            style={{ borderRadius: "50%", objectFit: "cover" }}
            src={value.teacher.user && value.teacher.user.picture ? value.teacher.user.picture : avatar_default}
          />
        </div>
        <div className="boxColumn">
          <label>{value.teacher.user ? decryptIfEncrypted(value.teacher.user.name) : ""}</label>
          <div className="rating startList">
            <p>{t("AVARAGE_RATING")}: </p> <span className="grades"> {value.teacher.averageRating} </span>{" "}
          </div>
        </div>
      </div>

      {user?.role != "b2b" && (
        <div className="endColumn">
          <button name="favorite" value={value.id} onClick={(e) => deleteTeacher(e, value.order)} className="delete">
            Delete <i className="fa fa-times-circle-o" aria-hidden="true"></i>
          </button>
          <DragHandle />
        </div>
      )}
    </div>
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div style={{ width: "100%" }}>
      {items.map((value, index) => (
        <SortableItem key={`item-${value.id}`} index={index} value={value} />
      ))}
    </div>
  ));

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <StudentTeacher>
        {user?.role != "b2b" && (
          <div className="filterContent" style={{ marginTop: "25px" }}>
            <h2>{t("ADD_TEACHER")}</h2>
            <form className="formulario">
              <div className="lineInput">
                <label htmlFor="teacher">{t("CARD_CLASS_TEACHER")}:</label>
                <select name="teacherId" value={teacherId} onChange={handleChange}>
                  <option value="">{t("SELECT")}</option>
                  {allTeachers?.map((teacher) => {
                    return (
                      <option key={teacher.id} value={teacher.teachers[0].id}>
                        {decryptIfEncrypted(teacher.name)}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="lineInput">
                <label htmlFor="favorite">{t("CHOOSE_LIST_TEACHER")}:</label>
                <div className="buttonsSelect">
                  <button name="favorite" className={isFavorite ? "active" : ""} onClick={handleChange}>
                    {t("FAVORITE_TEACHER")}
                  </button>
                  <button name="exception" className={!isFavorite ? "active" : ""} onClick={handleChange}>
                    {t("EXCEPTION_TEACHER")}
                  </button>
                </div>
              </div>

              <div className="lineInput">
                <div className="buttons">
                  <button name="addteacher" onClick={addTeacher}>
                    {t("ADD_TEACHER")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="teacherListBox">
          <h3>Favorite Teachers List</h3>
          {user?.role != "b2b" && (
            <div className="switch__container">
              <input
                id="switch-shadow"
                className="switch switch--shadow"
                type="checkbox"
                name="scheduleclass"
                checked={scheduleclass}
                onChange={handleScheduleClass}
              />
              <label htmlFor="switch-shadow">
                <span>Schedule class only with favorite teachers</span>
              </label>
            </div>
          )}
        </div>

        {teacherFavorites?.length > 0 ? (
          <SortableList items={teacherFavorites} onSortEnd={onSortEnd} useDragHandle={true} />
        ) : (
          <PlacehoderText label="No result" />
        )}

        <div className="teacherListBox">
          <h3>Exception List</h3>
        </div>

        {teacherExceptions?.length > 0 ? (
          teacherExceptions?.map((exception, index) => (
            <div key={index} className="bigBoxTeacher">
              <div className="boxInfo">
                <div className="boxColumn">
                  <img
                    src={exception.teacher.user.picture !== null ? exception.teacher.user.picture : avatar_default}
                    alt="Avatar"
                    width="48"
                    height="48"
                    className="avatarRound"
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />
                </div>
                <div className="boxColumn">
                  <label>{decryptIfEncrypted(exception.teacher.user.name)}</label>
                  <div className="rating startList">
                    <p>{t("AVARAGE_RATING")}:</p> <span className="grades">{exception.teacher.averageRating}</span>{" "}
                  </div>
                </div>
              </div>
              {user?.role != "b2b" && (
                <div className="endColumn">
                  <button
                    name="exception"
                    value={exception.id}
                    onClick={(e) => {
                      deleteTeacher(e, -1);
                    }}
                    className="delete"
                  >
                    Delete <i className="fa fa-times-circle-o" aria-hidden="true"></i>
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <PlacehoderText label="No result" />
        )}
      </StudentTeacher>

      <Dialog open={openAlert} onClose={() => setOpenAlert(false)} className="alert-dialog-slide">
        <DialogTitle className="alert-dialog-slide-title">{t("SOMETHING_WENT_WRONG")}</DialogTitle>
        <DialogContent className="alert-dialog-slide-content">{alertDescription}</DialogContent>
        <DialogActions className="alert-dialog-slide-actions">
          <button className="new-button close" onClick={() => setOpenAlert(false)}>
            {t("OK")}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Teachers;
